import React from 'react'
import { IconProps } from './model'

const IconDecide: React.FC<IconProps> = ({ src }: IconProps) => {
  const [imageSrc, setImageSrc] = React.useState('')

  React.useEffect(() => {
    if (src) {
      import(`src/assets/icon/${src}.svg`).then((value) => {
        setImageSrc(value.default)
      })
    }
  }, [src])

  return <img src={imageSrc} alt='' />
}

export default IconDecide
